
import { Union } from "../../fable_modules/fable-library-js.5.13.0/Types.js";
import { class_type, union_type } from "../../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { partition, sortBy, concat as concat_1, unzip, tail, mapIndexed, ofArrayWithTail, tryItem, item, exists as exists_1, cons, contains as contains_1, tryFind as tryFind_1, empty as empty_1, ofArray, singleton, isEmpty, append, collect, skip, length, filter, choose, map } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { toArray, value as value_2, defaultArg } from "../../fable_modules/fable-library-js.5.13.0/Option.js";
import { ofList as ofList_1, add, containsKey, empty, tryFind } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { FastSimulation__get_SimulatedTopSheet, SimulatedDesign__ComponentOfInstance_6546966D, SimulatedDesign__LabelOfInstance_1A26531, FastSimulation__getSheetNameOfInstance_1A26531, SimulatedDesign__SheetOfInstance_1A26531 } from "../../Simulator/SimTypes.js";
import { comparePrimitives, defaultOf, stringHash, numberHash, uncurry2, curry2, safeHash, equals, compare } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { ofInstanceCached, waveIndexOf } from "../../Simulator/FastSim/PortView.js";
import { dbg } from "../../Shared/Log.js";
import { ofList, contains, toList, exists } from "../../fable_modules/fable-library-js.5.13.0/Set.js";
import { getFastSim } from "../../Simulator/Simulator.js";
import { getCompGroup, isWaveSelected, groupHeading, wavesToIds, makeWave } from "./WaveSimHelpers.js";
import { concat, trimEnd } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { List_distinctBy, List_groupBy, List_except, List_countBy, List_distinct } from "../../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { input } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option, IInputType } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { ComponentGroup, CheckBoxStyle, showOnlySelected_, sheetSearchString_, Msg, WaveSimModel } from "../../Model/ModelType.js";
import { input as input_1, checkbox } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Checkbox.fs.js";
import { Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Optic_Get, Optic_Get_op_HatDot_Z146BA564 } from "../../Common/Optics.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Size_ISize, Color_IColor, Common_GenericOption } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { getSelectorHierarchy, emptyHierarchy, labelPathOf, pathKey, pathOfKey, nodeOf } from "./WaveSimHierarchy.js";
import { breadcrumbsOfTree, BreadcrumbConfig, Constants_defaultConfig } from "../MiscMenuView.js";
import { normalFontStyle, boldFontStyle, detailsProps, summaryProps, setWaveSheetSelectionOpen } from "./WaveSimStyle.js";
import { toList as toList_1 } from "../../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.13.0/Range.js";
import { Option as Option_1, select } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Select.fs.js";
import { keysOf } from "../Style.js";
import { ShortcutId } from "../../Common/KeyTypes.js";
import { viewWaveSelectRefusalPopup, viewWaveSelectConfirmationPopup } from "../UIPopups.js";
import { Card_foot, Card_body, Card_title, Card_head, Card_card, background, Option as Option_2, modal } from "../../fable_modules/Fulma.3.0.0/Components/Modal.fs.js";
import { right, left, level } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option as Option_3, delete$ } from "../../fable_modules/Fulma.3.0.0/Elements/Delete.fs.js";
import { Option as Option_4, button } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";

export const Constants_numPortColumns = 4;

export const Constants_maxWarningViewerWaves = 25;

export const Constants_maxRecommendedViewerWaves = 50;

export const Constants_maxAllowedViewerWaves = 100;

export const Constants_maxAutoExpandWaves = 50;

export const Constants_hierarchyPaneId = "WaveSelectHierarchyPane";

export const Constants_wavesPaneId = "WaveSelectWavesPane";

/**
 * What leaving the wave selection dialog with a given number of waveforms selected does.
 */
export class SelectionVerdict extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectionOk", "SelectionWarn", "SelectionRefuse"];
    }
    static SelectionOk = new SelectionVerdict(0, []);
    static SelectionWarn = new SelectionVerdict(1, []);
    static SelectionRefuse = new SelectionVerdict(2, []);
}

export function SelectionVerdict_$reflection() {
    return union_type("WaveSimSelectHelpers.SelectionVerdict", [], SelectionVerdict, () => [[], [], []]);
}

export function selectionVerdict(numWaves) {
    if (numWaves > Constants_maxAllowedViewerWaves) {
        return SelectionVerdict.SelectionRefuse;
    }
    else if (numWaves > Constants_maxRecommendedViewerWaves) {
        return SelectionVerdict.SelectionWarn;
    }
    else {
        return SelectionVerdict.SelectionOk;
    }
}

export class TableRow extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["TableRow"];
    }
}

export function TableRow_$reflection() {
    return union_type("WaveSimSelectHelpers.TableRow", [], TableRow, () => [[["Item", class_type("Fable.React.ReactElement", undefined)]]]);
}

export function waveRowIProps(props, rowItems) {
    let children_2;
    return new TableRow((children_2 = map((cell) => {
        const props_1 = [["style", {
            borderStyle: "none",
        }]];
        return react.createElement("td", keyValueList(props_1, 1), cell);
    }, rowItems), react.createElement("tr", keyValueList(props, 1), ...children_2)));
}

export function waveRow(props, rowItems) {
    return waveRowIProps([["style", keyValueList(props, 1)]], rowItems);
}

export function wavePropsTable(rows) {
    let props, children;
    const props_2 = [["style", {
        background: "#f0f0f0",
    }]];
    const children_2 = [(props = [["style", {}]], (children = map((_arg) => _arg.fields[0], rows), react.createElement("tbody", keyValueList(props, 1), ...children)))];
    return react.createElement("table", keyValueList(props_2, 1), ...children_2);
}

/**
 * The waves offered inside ONE instance.
 * 
 * Worked out from the DESIGN: the sheet that instance is a copy of names its own components, and
 * each is looked up in the simulation to get its ports and their step arrays. So this costs the
 * size of one sheet, however many times that sheet is instantiated.
 * 
 * It replaces an index of every wave in the simulation grouped by instance, which cost the whole
 * expansion to build - 208,896 entries on largeTest - to answer a question only ever asked about
 * the handful of instances on screen. The rule deciding which ports carry a wave is
 * FastCreate.portCarriesWave, the same one the wave index itself is built from, so the two
 * cannot disagree.
 * The waves of one instance, each paired with something read off the DESIGN component it belongs
 * to - its label, its type, whatever the caller needs to rank or filter on.
 * 
 * The ports come from `PortView.ofInstance`, which is the narrow question a remote simulator can
 * answer; the components they belong to come from the design. Both are the size of one sheet,
 * however many times that sheet is instantiated.
 */
export function waveIndicesOfInstanceBy(pick, fs, instance) {
    const comps = defaultArg(tryFind(SimulatedDesign__SheetOfInstance_1A26531(fs.Design, instance), fs.Design.DesignComponentsById), empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    return choose((port) => {
        let option_4;
        const option_2 = tryFind(port.PortComp, comps);
        option_4 = ((option_2 != null) ? pick(option_2) : undefined);
        if (option_4 != null) {
            return [value_2(option_4), waveIndexOf(instance, port)];
        }
        else {
            return undefined;
        }
    }, ofInstanceCached(fs, instance).ViewPorts);
}

export function waveIndicesOfInstance(fs, instance) {
    return map((port) => waveIndexOf(instance, port), ofInstanceCached(fs, instance).ViewPorts);
}

/**
 * The selected waves the simulation still has, which is what Show Only Selected shows and what the
 * ticks in the dialog are drawn from.
 * 
 * A selection outliving what it names is the ordinary consequence of the simulation being rebuilt,
 * and refreshWaveSim re-resolves it - but the dialog is drawn from whatever the model holds at that
 * moment, so it has to be able to read a selection that has not been re-resolved yet. Says so when
 * it happens, since a selection quietly shrinking is worth knowing about.
 * 
 * It used to check the CANDIDATES against the simulation as well. They are read out of WaveIndex or
 * out of WaveDetails, both of which the simulation is what defines, so there was nothing there to
 * find.
 */
export function consistentSelectedWaves(ws) {
    const okSelectedWaves = filter((selW) => containsKey(selW, ws.WaveDetails), ws.SelectedWaves);
    if (length(okSelectedWaves) !== length(ws.SelectedWaves)) {
        dbg(64, `wave consistency: ${length(okSelectedWaves)} valid selected waves of ${length(ws.SelectedWaves)}`);
    }
    return okSelectedWaves;
}

/**
 * Whether a sheet instance is one of `sheets`, or lies inside one.
 * 
 * An instance is the path of custom components between it and the root, innermost first, so an
 * enclosing instance is a SUFFIX of it - the same path with the inner steps taken off - and
 * containment is answered without consulting the simulation at all. This used to walk a stored
 * instance-to-parent map one level at a time, and needed a note about instances the simulation no
 * longer holds; a suffix test has nothing to look up and so nothing to miss.
 */
export function isSubSheetOf(_arg, sheets) {
    const sub = _arg;
    return exists((_arg_1) => {
        const outer = _arg_1;
        if (length(outer) <= length(sub)) {
            return equals(skip(length(sub) - length(outer), sub), outer);
        }
        else {
            return false;
        }
    }, sheets);
}

export function updateSheetString(newSheetName, ws) {
    const s = ws.SheetSearchString.trim().toUpperCase();
    if (s.endsWith("*")) {
        return newSheetName + "*";
    }
    else {
        return newSheetName;
    }
}

/**
 * Filtering function that applies an AND operation across four search criteria.
 * OfSheet is used to return the waves that match the sheet box
 * All returns all filtered waves without any sheet filtering.
 * 
 * `shown` is the sheet instances the two panes are going to draw - the handful the collapsed
 * hierarchy resolved to, one per node. A wave of any other instance cannot appear in either pane,
 * so it is dropped before anything else looks at it. That is the difference between work
 * proportional to the design somebody wrote and work proportional to what it expands to: main6 of
 * largeTest is seven sheets and tens of thousands of instances, carrying 208,896 waves between
 * them, and the dialog draws seven rows.
 * 
 * None means Show Only Selected, which is not restricted to the instances the hierarchy resolved
 * to: a wave already chosen inside an instance no combo box is currently showing must stay
 * reachable, or it could never be deselected. It is restricted to the waves that were CHOSEN,
 * which is a shorter list than any of them.
 * 
 * Every membership test here is against a Set. They were lists as long as the expansion, tested
 * once per wave, which is a product of two numbers that both grow with the design - the reason
 * opening this dialog on a large design took minutes. The worst case was the DEFAULT one: an empty
 * sheet box matches every instance, since every string contains the empty string.
 */
export function filterWaves(shown, wsModel) {
    let matchValue;
    const fs = getFastSim();
    const onShow = map((wi) => makeWave(wsModel, fs, wi), collect((instance) => waveIndicesOfInstance(fs, instance), toList(shown)));
    const elsewhere = choose((wi_2) => tryFind(wi_2, wsModel.WaveDetails), filter((wi_1) => !contains(wi_1.Id[1], shown), wsModel.SelectedWaves));
    const candidates = append(onShow, elsewhere);
    const selectedIds = ofList(consistentSelectedWaves(wsModel), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const matchWithBox = (searchString, matcher) => {
        const s = searchString.trim().toUpperCase();
        if ((s === "") ? true : (s === "*")) {
            return true;
        }
        else {
            return matcher.toUpperCase().indexOf(s) >= 0;
        }
    };
    const searchFilteredWaves = filter((wave) => {
        if (matchWithBox(wsModel.ComponentSearchString, wave.CompLabel) && matchWithBox(wsModel.PortSearchString, wave.PortLabel)) {
            if (!wsModel.ShowOnlySelected) {
                return true;
            }
            else {
                return contains(wave.WaveId, selectedIds);
            }
        }
        else {
            return false;
        }
    }, candidates);
    const sheetBox = wsModel.SheetSearchString.trim().toUpperCase();
    const sheet = trimEnd(sheetBox, "*");
    const allSubSheets = sheetBox.endsWith("*");
    const allSheets = List_distinct(append(toList(shown), List_distinct(map((wave_1) => wave_1.SheetId, elsewhere), {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    })), {
        Equals: equals,
        GetHashCode: (x_2) => (safeHash(x_2) | 0),
    });
    const nameOfSheet = (instance_1) => FastSimulation__getSheetNameOfInstance_1A26531(fs, instance_1).toUpperCase();
    const filteredSheets = ofList((matchValue = filter((instance_2) => (nameOfSheet(instance_2) === sheet), allSheets), isEmpty(matchValue) ? filter((instance_3) => (nameOfSheet(instance_3).indexOf(sheet) >= 0), allSheets) : matchValue), {
        Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
    });
    const searchSheets = ofList(filter((instance_4) => {
        if (contains(instance_4, filteredSheets)) {
            return true;
        }
        else if (allSubSheets) {
            return isSubSheetOf(instance_4, filteredSheets);
        }
        else {
            return false;
        }
    }, allSheets), {
        Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
    });
    return {
        All: searchFilteredWaves,
        OfSheet: filter((wave_2) => contains(wave_2.SheetId, searchSheets), searchFilteredWaves),
        Sheets: searchSheets,
    };
}

export const searchBoxContainerStyle = ["style", {
    marginRight: "10px",
}];

/**
 * Search box for sheet names.
 */
export function sheetSearchBox(wsModel, dispatch) {
    const children = [input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Value */ 8, [wsModel.SheetSearchString]), new Option(/* Props */ 15, [singleton(["style", {
        marginBottom: "1rem",
        width: "100%",
    }])]), new Option(/* Placeholder */ 12, ["Filter sheet names..."]), new Option(/* OnChange */ 13, [(value) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(wsm) => (new WaveSimModel(wsm.DefaultCursor, wsm.WSConfig, wsm.WSConfigDialog, wsm.State, wsm.WaveDetails, wsm.SelectedWaves, wsm.DefaultSelectionPending, wsm.FetchFailedAtMs, wsm.StartCycle, wsm.ShownCycles, wsm.SamplingZoom, wsm.CursorDisplayCycle, wsm.CursorExactClkCycle, wsm.ClkCycleBoxIsEmpty, wsm.Radix, wsm.WaveformColumnWidth, wsm.WaveModalActive, wsm.RamModalActive, wsm.PortSelectComp, wsm.RamComps, wsm.SelectedRams, wsm.RamStartLocation, wsm.RamRows, wsm.ShowSheetDetail, wsm.SelectedSheetInstance, wsm.ShowGroupDetail, wsm.HoveredLabel, wsm.DraggedIndex, wsm.PrevSelectedWaves, wsm.ScrollbarTbWidth, wsm.ScrollbarTbPos, wsm.ScrollbarTbOffset, wsm.ScrollbarBkgWidth, wsm.ScrollbarBkgRepCycs, wsm.ScrollbarQueueIsEmpty, (value.target.value).toLocaleUpperCase(), wsm.ComponentSearchString, wsm.PortSearchString, wsm.ShowOnlySelected))]));
    }])]))];
    return react.createElement("div", keyValueList([searchBoxContainerStyle], 1), ...children);
}

/**
 * A checkbox over one piece of the wave sim model, shown ticked or not by `isChecked` and toggled
 * by `toggle`.
 * 
 * `toggle` is given the state as it is when the update runs, not as it was when the box was drawn.
 * A box is drawn once and clicked later, and the model may have moved in between - the same reason
 * every handler here dispatches UpdateWSModel rather than replacing the model wholesale.
 */
export function waveCheckBox(state__, state___1, isChecked, toggle, name, ws, dispatch) {
    const state_ = [state__, curry2(state___1)];
    const props = [["style", {
        marginLeft: "15px",
        display: "flex",
        alignItems: "center",
        marginBottom: "20px",
    }]];
    const children = [checkbox(empty_1(), ofArray([input_1(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new HTMLAttr(/* Checked */ 62, [isChecked(Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, state_)(ws))]), new DOMAttr(/* OnChange */ 9, [(_arg) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, state_)(toggle)]));
    }])])]))), name]))];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

/**
 * A sheet filter ending in '*' means that sheet and everything inside it.
 */
export function selectAllSubsheetsBox(ws, dispatch) {
    return waveCheckBox(sheetSearchString_[0], uncurry2(sheetSearchString_[1]), (s) => s.endsWith("*"), (s_1) => {
        if (s_1.endsWith("*")) {
            return trimEnd(s_1, "*");
        }
        else {
            return s_1 + "*";
        }
    }, "All Subsheets", ws, dispatch);
}

export function showOnlySelectedBox(ws, dispatch) {
    return waveCheckBox(showOnlySelected_[0], uncurry2(showOnlySelected_[1]), (x) => x, (value) => !value, "Show Only Selected", ws, dispatch);
}

/**
 * Search box for component names.
 */
export function componentSearchBox(wsModel, dispatch) {
    const children = [input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Value */ 8, [wsModel.ComponentSearchString]), new Option(/* Props */ 15, [singleton(["style", {
        marginBottom: "1rem",
        width: "100%",
    }])]), new Option(/* Placeholder */ 12, ["Filter component labels..."]), new Option(/* OnChange */ 13, [(value) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(wsm) => (new WaveSimModel(wsm.DefaultCursor, wsm.WSConfig, wsm.WSConfigDialog, wsm.State, wsm.WaveDetails, wsm.SelectedWaves, wsm.DefaultSelectionPending, wsm.FetchFailedAtMs, wsm.StartCycle, wsm.ShownCycles, wsm.SamplingZoom, wsm.CursorDisplayCycle, wsm.CursorExactClkCycle, wsm.ClkCycleBoxIsEmpty, wsm.Radix, wsm.WaveformColumnWidth, wsm.WaveModalActive, wsm.RamModalActive, wsm.PortSelectComp, wsm.RamComps, wsm.SelectedRams, wsm.RamStartLocation, wsm.RamRows, wsm.ShowSheetDetail, wsm.SelectedSheetInstance, wsm.ShowGroupDetail, wsm.HoveredLabel, wsm.DraggedIndex, wsm.PrevSelectedWaves, wsm.ScrollbarTbWidth, wsm.ScrollbarTbPos, wsm.ScrollbarTbOffset, wsm.ScrollbarBkgWidth, wsm.ScrollbarBkgRepCycs, wsm.ScrollbarQueueIsEmpty, wsm.SheetSearchString, (value.target.value).toLocaleUpperCase(), wsm.PortSearchString, wsm.ShowOnlySelected))]));
    }])]))];
    return react.createElement("div", keyValueList([searchBoxContainerStyle], 1), ...children);
}

/**
 * Search box for port names.
 */
export function portSearchBox(wsModel, dispatch) {
    const children = [input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Value */ 8, [wsModel.PortSearchString]), new Option(/* Props */ 15, [singleton(["style", {
        marginBottom: "1rem",
        width: "100%",
    }])]), new Option(/* Placeholder */ 12, ["Filter port names..."]), new Option(/* OnChange */ 13, [(value) => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(wsm) => (new WaveSimModel(wsm.DefaultCursor, wsm.WSConfig, wsm.WSConfigDialog, wsm.State, wsm.WaveDetails, wsm.SelectedWaves, wsm.DefaultSelectionPending, wsm.FetchFailedAtMs, wsm.StartCycle, wsm.ShownCycles, wsm.SamplingZoom, wsm.CursorDisplayCycle, wsm.CursorExactClkCycle, wsm.ClkCycleBoxIsEmpty, wsm.Radix, wsm.WaveformColumnWidth, wsm.WaveModalActive, wsm.RamModalActive, wsm.PortSelectComp, wsm.RamComps, wsm.SelectedRams, wsm.RamStartLocation, wsm.RamRows, wsm.ShowSheetDetail, wsm.SelectedSheetInstance, wsm.ShowGroupDetail, wsm.HoveredLabel, wsm.DraggedIndex, wsm.PrevSelectedWaves, wsm.ScrollbarTbWidth, wsm.ScrollbarTbPos, wsm.ScrollbarTbOffset, wsm.ScrollbarBkgWidth, wsm.ScrollbarBkgRepCycs, wsm.ScrollbarQueueIsEmpty, wsm.SheetSearchString, wsm.ComponentSearchString, (value.target.value).toLocaleUpperCase(), wsm.ShowOnlySelected))]));
    }])]))];
    return react.createElement("div", keyValueList([searchBoxContainerStyle], 1), ...children);
}

/**
 * Displays a breadcrumb of sheets based on the current search and wave matches.
 * 
 * One pill per NODE of the collapsed hierarchy, not per instance: a sheet instantiated four times
 * inside one parent is one pill, and which of the four it stands for is the combo box in the
 * other pane. Both panes are drawn from the same hierarchy, so they cannot disagree about it.
 */
export function waveSelectBreadcrumbs(wsModel, hierarchy, filteredWaves, dispatch, model) {
    let props_4, children_4, props_2;
    if (model.CurrentProj != null) {
        getFastSim();
        const sheetCounts = List_countBy((wave) => wave.SheetId, filteredWaves.All, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        });
        const instanceOf = (sheet) => {
            const option_1 = nodeOf(hierarchy, sheet);
            if (option_1 != null) {
                return option_1.NodeInstance;
            }
            else {
                return undefined;
            }
        };
        const breadcrumbConfig = new BreadcrumbConfig(Constants_defaultConfig.AllowDuplicateSheets, Constants_defaultConfig.ShowLibrarySheet, Constants_defaultConfig.BreadcrumbIdPrefix, (sheet_4) => sheet_4.SheetName, (sheet_1) => {
            const matchValue_1 = instanceOf(sheet_1);
            let matchResult, instance_1;
            if (matchValue_1 != null) {
                if (contains(matchValue_1, filteredWaves.Sheets)) {
                    matchResult = 0;
                    instance_1 = matchValue_1;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new Color_IColor(/* IsCustomColor */ 19, ["pink"]);
                default:
                    return new Color_IColor(/* IsCustomColor */ 19, ["darkslategrey"]);
            }
        }, (sheet_3, dispatch_1) => {
            const matchValue_4 = instanceOf(sheet_3);
            if (matchValue_4 != null) {
                dispatch_1(new Msg(/* UpdateWSModel */ 13, [(ws) => setWaveSheetSelectionOpen(new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, updateSheetString(sheet_3.SheetName, ws), ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected), singleton(sheet_3.SheetPath), true)]));
            }
        }, Constants_defaultConfig.ElementProps, Constants_defaultConfig.ElementStyleProps, Constants_defaultConfig.ButtonOptions, (sheet_2) => {
            const matchValue_2 = instanceOf(sheet_2);
            if (matchValue_2 != null) {
                const instance_2 = matchValue_2;
                const matchValue_3 = tryFind_1((tupledArg) => equals(tupledArg[0], instance_2), sheetCounts);
                if (matchValue_3 == null) {
                    return 0;
                }
                else {
                    return matchValue_3[1] | 0;
                }
            }
            else {
                return 0;
            }
        }, (sheet_5) => {
            let option_3;
            return defaultArg((option_3 = nodeOf(hierarchy, sheet_5), (option_3 != null) ? option_3.NodeCollapsible : undefined), false);
        }, (sheet_6, dispatch_2) => {
            const show = !contains(sheet_6.SheetPath, wsModel.ShowSheetDetail);
            dispatch_2(new Msg(/* UpdateWSModel */ 13, [(ws_2) => setWaveSheetSelectionOpen(ws_2, singleton(sheet_6.SheetPath), show)]));
        });
        let hierarchyText;
        const sheetFilter = wsModel.SheetSearchString.toUpperCase().trim();
        const withSubsheets = sheetFilter.endsWith("*");
        const matchValue_5 = trimEnd(sheetFilter, "*");
        hierarchyText = ((matchValue_5 === "") ? "Design hierarchy: click to filter by sheet" : (withSubsheets ? concat("Design hierarchy: filtered by ", matchValue_5, " with subsheets") : concat("Design hierarchy: filtered by ", matchValue_5, " without subsheets")));
        const breadcrumbs = singleton((props_4 = [new HTMLAttr(/* ClassName */ 64, ["treePanel"]), ["style", {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "max-content",
            minWidth: "100%",
        }]], (children_4 = [(props_2 = [["style", {
            textAlign: "center",
            fontSize: "20px",
            fontWeight: 600,
            paddingBottom: "10px",
        }]], react.createElement("div", keyValueList(props_2, 1), hierarchyText)), breadcrumbsOfTree(breadcrumbConfig, hierarchy.HierTree, dispatch)], react.createElement("div", keyValueList(props_4, 1), ...children_4))));
        return react.createElement("div", {}, ...breadcrumbs);
    }
    else {
        return react.createElement("div", {}, "No project open");
    }
}

export function toggleWaveSelection(index, wsModel, dispatch) {
    dispatch(new Msg(/* GenerateWaveforms */ 14, [(wsModel_1) => (new WaveSimModel(wsModel_1.DefaultCursor, wsModel_1.WSConfig, wsModel_1.WSConfigDialog, wsModel_1.State, wsModel_1.WaveDetails, contains_1(index, wsModel_1.SelectedWaves, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }) ? List_except([index], wsModel_1.SelectedWaves, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }) : cons(index, wsModel_1.SelectedWaves), wsModel_1.DefaultSelectionPending, wsModel_1.FetchFailedAtMs, wsModel_1.StartCycle, wsModel_1.ShownCycles, wsModel_1.SamplingZoom, wsModel_1.CursorDisplayCycle, wsModel_1.CursorExactClkCycle, wsModel_1.ClkCycleBoxIsEmpty, wsModel_1.Radix, wsModel_1.WaveformColumnWidth, wsModel_1.WaveModalActive, wsModel_1.RamModalActive, wsModel_1.PortSelectComp, wsModel_1.RamComps, wsModel_1.SelectedRams, wsModel_1.RamStartLocation, wsModel_1.RamRows, wsModel_1.ShowSheetDetail, wsModel_1.SelectedSheetInstance, wsModel_1.ShowGroupDetail, wsModel_1.HoveredLabel, wsModel_1.DraggedIndex, wsModel_1.PrevSelectedWaves, wsModel_1.ScrollbarTbWidth, wsModel_1.ScrollbarTbPos, wsModel_1.ScrollbarTbOffset, wsModel_1.ScrollbarBkgWidth, wsModel_1.ScrollbarBkgRepCycs, wsModel_1.ScrollbarQueueIsEmpty, wsModel_1.SheetSearchString, wsModel_1.ComponentSearchString, wsModel_1.PortSearchString, wsModel_1.ShowOnlySelected))]));
}

/**
 * Select or deselect every wave a row covers.
 * 
 * All of them. Both this and the checkbox above it used to keep only the waves at the shallowest
 * access path they were given, from when a sheet's row could hold the waves of its whole subtree
 * and ticking it had to mean that sheet's own signals rather than its children's. A row is now the
 * waves of one component group within one sheet INSTANCE, or of one instance, so they are all at
 * one depth and the shallowest of them is all of them.
 */
export function toggleSelectSubGroup(wsModel, dispatch, selected, waves) {
    dispatch(new Msg(/* GenerateWaveforms */ 14, [(wsModel_1) => (new WaveSimModel(wsModel_1.DefaultCursor, wsModel_1.WSConfig, wsModel_1.WSConfigDialog, wsModel_1.State, wsModel_1.WaveDetails, selected ? append(wsModel_1.SelectedWaves, waves) : List_except(waves, wsModel_1.SelectedWaves, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), wsModel_1.DefaultSelectionPending, wsModel_1.FetchFailedAtMs, wsModel_1.StartCycle, wsModel_1.ShownCycles, wsModel_1.SamplingZoom, wsModel_1.CursorDisplayCycle, wsModel_1.CursorExactClkCycle, wsModel_1.ClkCycleBoxIsEmpty, wsModel_1.Radix, wsModel_1.WaveformColumnWidth, wsModel_1.WaveModalActive, wsModel_1.RamModalActive, wsModel_1.PortSelectComp, wsModel_1.RamComps, wsModel_1.SelectedRams, wsModel_1.RamStartLocation, wsModel_1.RamRows, wsModel_1.ShowSheetDetail, wsModel_1.SelectedSheetInstance, wsModel_1.ShowGroupDetail, wsModel_1.HoveredLabel, wsModel_1.DraggedIndex, wsModel_1.PrevSelectedWaves, wsModel_1.ScrollbarTbWidth, wsModel_1.ScrollbarTbPos, wsModel_1.ScrollbarTbOffset, wsModel_1.ScrollbarBkgWidth, wsModel_1.ScrollbarBkgRepCycs, wsModel_1.ScrollbarQueueIsEmpty, wsModel_1.SheetSearchString, wsModel_1.ComponentSearchString, wsModel_1.PortSearchString, wsModel_1.ShowOnlySelected))]));
}

export function waveCheckBoxItem(wsModel, waveIds, dispatch) {
    const checkBoxState = exists_1((w) => contains_1(w, wsModel.SelectedWaves, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), waveIds);
    return checkbox(empty_1(), singleton(input_1(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new HTMLAttr(/* Checked */ 62, [checkBoxState]), new DOMAttr(/* OnChange */ 9, [(_arg) => {
        toggleSelectSubGroup(wsModel, dispatch, !checkBoxState, waveIds);
    }]), ["style", {
        marginRight: "10px",
    }]])])))));
}

/**
 * One row of the selection table: a checkbox over all of `waves`, and a summary that opens to show
 * `rows` - each of which is a group of components, or a whole sheet, and may open in turn.
 * 
 * `aboveRows` goes in the body, between the summary and the table. For a sheet that is the combo
 * box choosing which of its instances the rows belong to, which belongs there rather than in the
 * summary, since a click on the summary opens and closes the row. `null` where there is nothing.
 * 
 * In general waves.Length > rows.Length, since one row typically holds several ports.
 */
export function makeSummaryItem(showDetails, ws, summaryItem, aboveRows, rows, cBox, waves, dispatch) {
    let props_2, children_2, props;
    return waveRowIProps(summaryProps(false, cBox, ws, dispatch), ofArray([waveCheckBoxItem(ws, wavesToIds(waves), dispatch), (props_2 = detailsProps(showDetails, cBox, ws, dispatch), (children_2 = [(props = summaryProps(true, cBox, ws, dispatch), react.createElement("summary", keyValueList(props, 1), summaryItem)), aboveRows, wavePropsTable(rows)], react.createElement("details", keyValueList(props_2, 1), ...children_2)))]));
}

export function makeFlatGroupRow(showDetails, ws, nodeKey, grp, wavesInGroup, dispatch) {
    const portsPerRow = Constants_numPortColumns | 0;
    const summaryReact = groupHeading(grp);
    const rowItems = collect((tupledArg) => map((tupledArg_1) => {
        let props_6, children_4;
        const waves_2 = tupledArg_1[1];
        const isFirst = item(0, waves_2).Column === 0;
        return waveRow(empty_1(), cons((props_6 = [["style", keyValueList(append(ofArray([new CSSProp(/* MarginRight */ 225, ["10px"]), new CSSProp(/* MarginLeft */ 224, ["10px"]), new CSSProp(/* Color */ 103, ["blue"])]), boldFontStyle), 1)]], (children_4 = [isFirst ? item(0, waves_2).W.CompLabel : ""], react.createElement("p", keyValueList(props_6, 1), ...children_4))), collect((i_1) => {
            let props_4, children_2, props, props_2;
            const _arg_1 = tryItem(i_1, waves_2);
            if (_arg_1 != null) {
                const wave_2 = _arg_1;
                const isSelected = isWaveSelected(wave_2.W.WaveId, ws);
                const fontStyle = isSelected ? boldFontStyle : normalFontStyle;
                return singleton((props_4 = [["style", {
                    display: "flex",
                    alignItems: "center",
                }]], (children_2 = [(props = [new HTMLAttr(/* Type */ 159, ["Checkbox"]), new DOMAttr(/* OnChange */ 9, [(_arg) => {
                    toggleWaveSelection(wave_2.W.WaveId, ws, dispatch);
                }]), new HTMLAttr(/* Checked */ 62, [isSelected]), ["style", keyValueList(ofArrayWithTail([new CSSProp(/* MarginLeft */ 224, ["10px"]), new CSSProp(/* MarginRight */ 225, ["5px"])], fontStyle), 1)]], react.createElement("input", keyValueList(props, 1))), (props_2 = [["style", keyValueList(cons(new CSSProp(/* MarginRight */ 225, ["10px"]), fontStyle), 1)]], react.createElement("p", keyValueList(props_2, 1), wave_2.W.PortLabel))], react.createElement("div", keyValueList(props_4, 1), ...children_2))));
            }
            else {
                return singleton("");
            }
        }, toList_1(rangeDouble(0, 1, portsPerRow - 1)))));
    }, List_groupBy((waves_1) => (~~(waves_1.Column / portsPerRow) | 0), mapIndexed((i, wave_1) => ({
        Column: i,
        W: wave_1,
    }), tupledArg[1]), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (numberHash(x_1) | 0),
    })), List_groupBy((wave) => wave.CompLabel, wavesInGroup, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
    return makeSummaryItem(showDetails, ws, summaryReact, defaultOf(), rowItems, new CheckBoxStyle(/* GroupItem */ 0, [grp, nodeKey]), wavesInGroup, dispatch);
}

function instanceSelector(node, dispatch) {
    let props, props_4, children_4;
    const design = getFastSim().Design;
    const matchValue = node.NodeInstances;
    const matchValue_1 = node.NodeInstance;
    let matchResult, shown;
    if (!isEmpty(matchValue)) {
        if (!isEmpty(tail(matchValue))) {
            if (matchValue_1 != null) {
                matchResult = 0;
                shown = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const props_6 = [["style", {
                display: "flex",
                alignItems: "center",
                marginLeft: "10px",
            }]];
            const children_6 = [(props = [["style", keyValueList(cons(new CSSProp(/* MarginRight */ 225, ["8px"]), normalFontStyle), 1)]], react.createElement("p", keyValueList(props, 1), "Instance")), select(singleton(new Option_1(/* Size */ 0, [Size_ISize.IsSmall])), singleton((props_4 = [["style", {
                boxSizing: "border-box",
            }], new HTMLAttr(/* Value */ 161, [shown]), new DOMAttr(/* OnChange */ 9, [(ev) => {
                const chosen = pathOfKey(ev.target.value);
                dispatch(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, add(node.NodeKey, chosen, ws.SelectedSheetInstance), ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]));
            }])], (children_4 = map((instance_1) => {
                let instance;
                const props_2 = [new HTMLAttr(/* Value */ 161, [pathKey(instance_1)])];
                const children_2 = [(instance = instance_1, defaultArg(SimulatedDesign__LabelOfInstance_1A26531(design, instance), pathKey(instance)))];
                return react.createElement("option", keyValueList(props_2, 1), ...children_2);
            }, node.NodeInstances), react.createElement("select", keyValueList(props_4, 1), ...children_4)))))];
            return react.createElement("div", keyValueList(props_6, 1), ...children_6);
        }
        default:
            return defaultOf();
    }
}

function makeInstanceRows(showDetails, ws, fs, waves, dispatch) {
    return map((tupledArg) => {
        let props, children;
        const instance = tupledArg[0];
        const wavesOfInstance = tupledArg[1];
        const groupRows = map((tupledArg_1) => makeFlatGroupRow(showDetails, ws, singleton(pathKey(instance)), tupledArg_1[0], tupledArg_1[1], dispatch), List_groupBy((wave) => {
            let option_1;
            return defaultArg((option_1 = SimulatedDesign__ComponentOfInstance_6546966D(fs.Design, wave.WaveId.Id), (option_1 != null) ? getCompGroup(option_1.Type) : undefined), new ComponentGroup(/* Component */ 10, ["unknown"]));
        }, wavesOfInstance, {
            Equals: equals,
            GetHashCode: (x_1) => (safeHash(x_1) | 0),
        }));
        return makeSummaryItem(showDetails, ws, (props = [new HTMLAttr(/* Title */ 158, [labelPathOf(fs, instance)])], (children = [FastSimulation__getSheetNameOfInstance_1A26531(fs, instance)], react.createElement("span", keyValueList(props, 1), ...children))), defaultOf(), groupRows, new CheckBoxStyle(/* SheetItem */ 1, [singleton(pathKey(instance))]), wavesOfInstance, dispatch);
    }, List_groupBy((w) => w.SheetId, waves, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }));
}

function makeNodeRows(showDetails, ws, fs, hierarchy, waves, dispatch) {
    const wavesByInstance = ofList_1(List_groupBy((w) => w.SheetId, waves, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    const rowsOf = (sheet) => {
        let option_1;
        const matchValue = nodeOf(hierarchy, sheet);
        if (matchValue != null) {
            const node = matchValue;
            let patternInput_1;
            const tupledArg = unzip(map((sub) => {
                const patternInput = rowsOf(sub);
                const own = patternInput[0];
                const flat = patternInput[1];
                const matchValue_1 = nodeOf(hierarchy, sub);
                let matchResult, child_1;
                if (matchValue_1 != null) {
                    if (matchValue_1.NodeMultiRoute) {
                        matchResult = 0;
                        child_1 = matchValue_1;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return [ofArray(toArray(own)), flat];
                    default:
                        return [empty_1(), append(ofArray(toArray(own)), flat)];
                }
            }, sheet.SubSheets));
            patternInput_1 = [concat_1(tupledArg[0]), concat_1(tupledArg[1])];
            const nested_1 = patternInput_1[0];
            const flat_2 = patternInput_1[1];
            const wavesOfNode = defaultArg((option_1 = node.NodeInstance, (option_1 != null) ? tryFind(option_1, wavesByInstance) : undefined), empty_1());
            const groupRows = map((tupledArg_1) => makeFlatGroupRow(showDetails, ws, node.NodeKey, tupledArg_1[0], tupledArg_1[1], dispatch), List_groupBy((wave) => {
                let option_4;
                return defaultArg((option_4 = SimulatedDesign__ComponentOfInstance_6546966D(fs.Design, wave.WaveId.Id), (option_4 != null) ? getCompGroup(option_4.Type) : undefined), new ComponentGroup(/* Component */ 10, ["unknown"]));
            }, wavesOfNode, {
                Equals: equals,
                GetHashCode: (x_2) => (safeHash(x_2) | 0),
            }));
            if (isEmpty(groupRows) && isEmpty(nested_1)) {
                return [undefined, flat_2];
            }
            else {
                return [makeSummaryItem(showDetails && !node.NodeCollapsible, ws, sheet.SheetName, instanceSelector(node, dispatch), append(groupRows, nested_1), new CheckBoxStyle(/* SheetItem */ 1, [node.NodeKey]), wavesOfNode, dispatch), flat_2];
            }
        }
        else {
            return [undefined, empty_1()];
        }
    };
    const patternInput_2 = rowsOf(hierarchy.HierTree);
    return append(ofArray(toArray(patternInput_2[0])), patternInput_2[1]);
}

export function makeSelectionTable(ws, hierarchy, waves, dispatch) {
    let props, children;
    const fs = getFastSim();
    const waves_1 = sortBy((wave) => wave.ViewerDisplayName, waves, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const sheetNum = length(List_distinctBy((w) => w.SheetId, waves_1, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    })) | 0;
    const showDetails = ((length(waves_1) < Constants_maxAutoExpandWaves) ? true : ws.ShowOnlySelected) ? true : (sheetNum < 2);
    const shown = ofList(choose((node) => node.NodeInstance, hierarchy.HierOrder), {
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    });
    const patternInput = partition((wave_1) => contains(wave_1.SheetId, shown), waves_1);
    const subSheetRows = append(makeNodeRows(showDetails, ws, fs, hierarchy, patternInput[0], dispatch), makeInstanceRows(showDetails, ws, fs, patternInput[1], dispatch));
    let messageColour;
    const matchValue = length(ws.SelectedWaves) | 0;
    messageColour = ((matchValue > Constants_maxAllowedViewerWaves) ? "darkred" : ((matchValue > Constants_maxRecommendedViewerWaves) ? "red" : ((matchValue > Constants_maxWarningViewerWaves) ? "orange" : "green")));
    const props_2 = [["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "max-content",
        minWidth: "100%",
    }]];
    const children_2 = [(props = [["style", {
        fontSize: "20px",
        fontWeight: "600",
        color: messageColour,
        paddingBottom: "15px",
    }]], (children = [`${length(ws.SelectedWaves)} waveforms selected`], react.createElement("p", keyValueList(props, 1), ...children))), wavePropsTable(subSheetRows)];
    return react.createElement("div", keyValueList(props_2, 1), ...children_2);
}

/**
 * The line of small text in the gap between the search boxes and the two panes.
 * 
 * Which line it is depends on whether either pane is having to scroll sideways - a fact about how
 * wide the browser laid its content out, which nothing in the model knows, so it is read off the
 * panes themselves as the code editor reads its own scroll container. The read is of the DOM the
 * last render left, so the dialog's first frame has nothing to measure and a change of filter is
 * followed a frame late. For a hint that is fine, and it is the price of not keeping a copy of a
 * browser measurement in the model, where it would have to be kept true.
 * 
 * Sideways only. Scrolling down is what a list of waveforms normally does, so counting it would
 * leave the warning permanently up and the tip under it never read.
 */
export function paneHintLine() {
    let s_2;
    const scrollsSideways = (paneId) => {
        const el = document.getElementById(paneId);
        if (!((el == null || el === 'undefined'))) {
            return el.scrollWidth > el.clientWidth;
        }
        else {
            return false;
        }
    };
    const patternInput = (scrollsSideways(Constants_hierarchyPaneId) ? true : scrollsSideways(Constants_wavesPaneId)) ? ["red", ofArray(["App Zoom-out ", keysOf(ShortcutId.ScAppZoomOut), " to reduce scrolling"])] : ["black", singleton((s_2 = "NB: You can exit this dialog and select waveforms directly from the canvas, using right-click on a symbol or wire.", s_2))];
    const props = [["style", {
        color: patternInput[0],
        fontSize: "12px",
        marginLeft: "10px",
    }]];
    return react.createElement("div", keyValueList(props, 1), ...patternInput[1]);
}

/**
 * Displays the modal for wave selection. The top row shows the serach boxes.
 * Below a two‑column grid shows the wave selection (left) and breadcrumbs (right).
 */
export function selectWavesModal(wsModel, dispatch, model) {
    let props_2, children_2, props_4, children_4, props_6, children_6;
    const closeModal = () => {
        dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_1) => {
            const ws = new WaveSimModel(ws_1.DefaultCursor, ws_1.WSConfig, ws_1.WSConfigDialog, ws_1.State, ws_1.WaveDetails, ws_1.SelectedWaves, ws_1.DefaultSelectionPending, ws_1.FetchFailedAtMs, ws_1.StartCycle, ws_1.ShownCycles, ws_1.SamplingZoom, ws_1.CursorDisplayCycle, ws_1.CursorExactClkCycle, ws_1.ClkCycleBoxIsEmpty, ws_1.Radix, ws_1.WaveformColumnWidth, false, ws_1.RamModalActive, ws_1.PortSelectComp, ws_1.RamComps, ws_1.SelectedRams, ws_1.RamStartLocation, ws_1.RamRows, ws_1.ShowSheetDetail, ws_1.SelectedSheetInstance, ws_1.ShowGroupDetail, ws_1.HoveredLabel, ws_1.DraggedIndex, ws_1.PrevSelectedWaves, ws_1.ScrollbarTbWidth, ws_1.ScrollbarTbPos, ws_1.ScrollbarTbOffset, ws_1.ScrollbarBkgWidth, ws_1.ScrollbarBkgRepCycs, ws_1.ScrollbarQueueIsEmpty, ws_1.SheetSearchString, ws_1.ComponentSearchString, ws_1.PortSearchString, ws_1.ShowOnlySelected);
            return new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, "", "", "", false);
        }]));
    };
    const handleModalClose = (_arg) => {
        const numWaves = length(wsModel.SelectedWaves) | 0;
        const matchValue = selectionVerdict(numWaves);
        switch (matchValue.tag) {
            case 1: {
                viewWaveSelectConfirmationPopup(Constants_maxRecommendedViewerWaves, numWaves, (finish, _arg_1) => {
                    dispatch(Msg.ClosePopup);
                    if (finish) {
                        closeModal();
                    }
                }, dispatch);
                break;
            }
            case 0: {
                closeModal();
                break;
            }
            default:
                viewWaveSelectRefusalPopup(Constants_maxAllowedViewerWaves, numWaves, dispatch);
        }
    };
    if (!wsModel.WaveModalActive) {
        return react.createElement("div", {});
    }
    else {
        const fs = getFastSim();
        const hierarchy = (FastSimulation__get_SimulatedTopSheet(fs) === "") ? emptyHierarchy : getSelectorHierarchy(fs, wsModel);
        const filteredWaves = filterWaves(ofList(choose((node) => node.NodeInstance, hierarchy.HierOrder), {
            Compare: (x, y) => (compare(x, y) | 0),
        }), wsModel);
        return modal(ofArray([new Option_2(/* IsActive */ 1, [wsModel.WaveModalActive]), new Option_2(/* Props */ 0, [singleton(["style", {
            zIndex: 20000,
        }])])]), ofArray([background(singleton(new Common_GenericOption(/* Props */ 1, [singleton(new DOMAttr(/* OnClick */ 40, [handleModalClose]))])), empty_1()), Card_card(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
            minWidth: "95%",
        }])])), ofArray([Card_head(empty_1(), singleton(Card_title(empty_1(), singleton(level(empty_1(), ofArray([left(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
            fontSize: "20px",
            fontWeight: "600",
        }])])), singleton("Select Waveforms using selection pane checkboxes. Filter using top boxes or clicking hierarchy")), right(empty_1(), singleton(delete$(ofArray([new Option_3(/* Size */ 0, [Size_ISize.IsMedium]), new Option_3(/* OnClick */ 3, [handleModalClose])]), empty_1())))])))))), Card_head(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
            backgroundColor: "white",
            border: "none",
            margin: "0",
            padding: "0",
            height: "auto",
            borderTopLeftRadius: "0",
            borderTopRightRadius: "0",
            flexDirection: "column",
            alignItems: "flex-start",
        }])])), ofArray([(props_2 = [["style", {
            gridColumn: "1 / span 2",
            marginBottom: "15px",
            marginTop: "15px",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginLeft: "10px",
        }]], (children_2 = [componentSearchBox(wsModel, dispatch), portSearchBox(wsModel, dispatch), sheetSearchBox(wsModel, dispatch), selectAllSubsheetsBox(wsModel, dispatch), showOnlySelectedBox(wsModel, dispatch)], react.createElement("div", keyValueList(props_2, 1), ...children_2))), paneHintLine()])), Card_body(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
            height: "70vh",
            overflowY: "visible",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridGap: "10px",
            width: "100%",
        }])])), ofArray([(props_4 = [new HTMLAttr(/* Id */ 99, [Constants_hierarchyPaneId]), ["style", {
            height: "100%",
            overflow: "auto",
        }]], (children_4 = [waveSelectBreadcrumbs(wsModel, hierarchy, filteredWaves, dispatch, model)], react.createElement("div", keyValueList(props_4, 1), ...children_4))), (props_6 = [new HTMLAttr(/* Id */ 99, [Constants_wavesPaneId]), ["style", {
            height: "100%",
            overflow: "auto",
        }]], (children_6 = [makeSelectionTable(wsModel, hierarchy, filteredWaves.OfSheet, dispatch)], react.createElement("div", keyValueList(props_6, 1), ...children_6)))])), Card_foot(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
            display: "inline-block",
            float: "right",
        }])])), singleton(button(ofArray([new Option_4(/* OnClick */ 18, [(_arg_2) => {
            handleModalClose();
        }]), new Option_4(/* Color */ 0, [Color_IColor.IsSuccess]), new Option_4(/* Props */ 17, [singleton(["style", {
            display: "inline-block",
            float: "right",
        }])])]), singleton("Done"))))]))]));
    }
}

